// extracted by mini-css-extract-plugin
module.exports = {"like":"like_like__AQUAV","active":"like_active__3L1UW","container":"like_container__bd6rn","visible":"like_visible__0T0UY"};